module.exports = __webpack_public_path__ + "static/media/1021152.d3cd5939.png";